
import { guid } from '@/utils'
import { computed, defineComponent, PropType } from 'vue'

enum ToggleOrientation {
  Horizontal = 'horizontal',
  Vertical = 'vertical'
}

export default defineComponent({
  name: 'Toggle',
  props: {
    id: {
      type: String
    },
    modelValue: {
      type: Boolean,
      default: false
    },
    label: {
      type: String
    },
    orientation: {
      type: String as PropType<ToggleOrientation>,
      default: ToggleOrientation.Horizontal
    }
  },
  emits: ['update:modelValue', 'toggle'],
  setup (props, { emit }) {
    const switchValue = computed<boolean>({
      get: () => {
        return props.modelValue
      },
      set: (value) => {
        emit('update:modelValue', value)
      }
    })

    function toggle (e) {
      // switchValue is not updated yet at this point, so emit the inverse
      emit('update:modelValue', !switchValue.value)
      emit('toggle', !switchValue.value)
    }

    return {
      uid: props.id || guid(),
      switchValue,
      toggle,
      ToggleOrientation
    }
  }
})

